import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  score: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    width: '30px',
    minHeight: '30px',
    borderRadius: '15px',
    margin: '5px',
    cursor: 'pointer',
  },
  enabledScore: {
    color: '#2C2D3E',
    backgroundColor: '#FFFFFF',
    border: 'solid 1px #8287d1',
    '&:hover': {
      background: '#9DA1E0',
      color: '#FFFFFF',
    },
  },
  disabledScore: {
    color: '#2C2D3E',
    backgroundColor: '#EDEDF6',
    cursor: 'not-allowed'
  },
  activeScore: {
    background: '#3C419A',
    color: '#FFFFFF',
  },
  disabledActiveScore: {
    background: '#6F707B',
    color: '#FFFFFF',
    cursor: 'not-allowed'
  },
}));
